import WOW from "wow.js";
// import "animate.css";

export default defineNuxtPlugin((nuxtApp) => {
    new WOW({
        resetAnimation: false,
    }).init();
});
